import React from 'react'
import { Box } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'

type Props = {
  savedId: string
}

export const SavedCaution: React.FC<Props> = ({ savedId }) => {
  const { t } = useLocale()
  if (savedId.length === 0) return <></>
  return (
    <Box color={'blue'} p={2} pt={4}>
      {t.SAVE_CAUTION}
    </Box>
  )
}
